module.exports = __webpack_public_path__ + "at.no2.2436c5de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/at.no2.jpg
// module id = puxL
// module chunks = 0